let averageRegistrationTimeMs = InitialFileRegistrationTimeMs;

export const getAverageRegistrationTimeMs = () => averageRegistrationTimeMs;

export const trackFileRegistrationTime = (measurement: number) => {
  averageRegistrationTimeMs = Math.round((averageRegistrationTimeMs + measurement) / 2);
};
